import React from 'react';
import { Link } from "react-router-dom";
import './Header.css';


const Header = (props) => {
    return (
        <header className="header">
            {/* <Canvas icons={props.icons} /> */}
            <h1>Softies</h1>
            <Link to="/about">About</Link>
            <Link to="/licence">Licence</Link>
            <Link to="/request">Request</Link>
        </header>
    )
}

export default Header;
